
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/UserDocs/AdvancedTopics/LanguageReference",
      function () {
        return require("private-next-pages/docs/UserDocs/AdvancedTopics/LanguageReference.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/UserDocs/AdvancedTopics/LanguageReference"])
      });
    }
  